module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Abonnement_ro.4d587f8c.jpg";